import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { ResetPasswordForm } from '../components/Auth/ResetPasswordForm';

export const ResetPasswordPage: React.FC = () => {
  return (
    <Layout showSidebar={false}>
      <ResetPasswordForm />
    </Layout>
  );
};
